import * as Partners from "../../assets/";

export const DadosParceiro = [
  {
    src: Partners.parceiro1,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro2,
    width: "500px",
    height: "150x",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro3,
    width: "150px",
    height: "150x",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro4,
    width: "368px",
    height: "150x",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro5,
    width: "300px",
    height: "150x",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro6,
    width: "247.45px",
    height: "150x",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro7,
    width: "206px",
    height: "150x",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro8,
    width: "543px",
    height: "150x",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro9,
    width: "210px",
    height: "150x",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro10,
    width: "129.35px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro11,
    width: "252.03px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro12,
    width: "149.64px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro13,
    width: "139.86px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro14,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro15,
    width: "403px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro16,
    width: "148.29px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro17,
    width: "398.18px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro18,
    width: "356.48px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro19,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro20,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro21,
    width: "311.29px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro22,
    width: "451.29px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro23,
    width: "151.39px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro24,
    width: "273.5px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro25,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro26,
    width: "538px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro27,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro28,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro29,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro30,
    width: "116.09px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro31,
    width: "231.27px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro32,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro33,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro34,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro35,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro36,
    width: "278.57px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro37,
    width: "150.38px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro38,
    width: "436.66px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro39,
    width: "180.38px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro40,
    width: "150px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro41,
    width: "152.26px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro42,
    width: "215.15px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro43,
    width: "469.2px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro44,
    width: "151.09px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro45,
    width: "373.01px",
    height: "150px",
    alt: "parceiroPhoto",
  },
  {
    src: Partners.parceiro46,
    width: "165.14px",
    height: "150px",
    alt: "parceiroPhoto",
  },
];
